export const GeneratingSpinner = () => (
  <span className="inline-flex items-start mt-10 gap-2 text-gray-400">
    <span className="flex space-x-1">
      <span
        className="h-2 w-2 bg-blue-500 rounded-full animate-bounce"
        style={{ animationDelay: "0s" }}
      ></span>
      <span
        className="h-2 w-2 bg-blue-500 rounded-full animate-bounce"
        style={{ animationDelay: "0.2s" }}
      ></span>
      <span
        className="h-2 w-2 bg-blue-500 rounded-full animate-bounce"
        style={{ animationDelay: "0.4s" }}
      ></span>
    </span>
  </span>
)
